import { createFileRoute } from '@tanstack/react-router'

import { MulticardUsageScreen } from './-components/multicard-usage-screen.tsx'

export const Route = createFileRoute('/payments/multicard-usage')({
  component: MulticardUsageScreen
})
